<template>
<!--  6:36-->
  <div>
    <cancel-heading
      subheading="Please tell me how we can improve. "
    >Hey, it's Don Costa - One thing...</cancel-heading>

    <p class="owner_feedback--quote">"I read every single one of these and your opinions and honest feedback really matter to me."</p>
    <p class="owner_feedback--author">-- Don Costa - CEO, Forefront CRM</p>

    <form-field-textarea
      v-model="feedback"
      @input="$emit('input', feedback);"
      placeholder="We read every answer"
    />
  </div>
</template>

<script>
import CancelHeading from "./components/CancelHeading.vue";
import CancelContent from "./components/CancelContent.vue";

export default {
  name: "OwnerFeedback",
  components: {CancelContent, CancelHeading},
  props: {
    value: {},
  },
  data() {
    return {
      feedback: null
    }
  },
}
</script>

<style lang="scss" scoped>
.owner_feedback--quote {
  margin-bottom: 4px;
  line-height: 1.3;
}

.owner_feedback--author {
  margin-bottom: 12px;
  padding-left: 10px;
  font-size: 0.75rem;
}
</style>
